import React from "react";
import "../styles/TeamScore.css";

interface TeamScoreProps {
  teamId: number;
  teamName?: string;
  teamColor: string;
  score: number;
  opponentScore: number;
  matchPoint: number;
  incrementScoreAction: (teamId: number) => void;
}

const TeamScore: React.FC<TeamScoreProps> = ({
  teamId,
  teamName,
  teamColor,
  score,
  opponentScore,
  matchPoint,
  incrementScoreAction,
}) => {
  return (
    <button
      key={teamId}
      type="button"
      className={`btn btn-light team-score-button team-score-${teamColor}`}
      onClick={() => incrementScoreAction(teamId)}
    >
      <div className="team-score-body">{score}</div>
      {score === matchPoint && <div className="winner-text">Winner!</div>}
    </button>
  );
};

export default TeamScore;
